import { first, get, has } from 'lodash';
import { getBoatUrl } from './urlHelpers/boat';

export const getProductSchema = (listing, { getTitle, getCurrency }) => {
  let firstImage = first(listing.media);
  const description = get(listing, 'description', '');
  const htmlTagSanitizerRegex = /(<([^>]+)>)/ig;
  const sanitizedDescription = description.replace(htmlTagSanitizerRegex, '');
  if (has(listing.price, 'type') && firstImage) {
    return ({
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: getTitle(listing),
      image: firstImage.url,
      description: sanitizedDescription,
      url: getBoatUrl(listing),
      brand: {
        '@type': 'Organization',
        name: get(listing, 'make', ''),
      },
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        priceCurrency: getCurrency(),
        price: get(listing, `price.type.amount.${getCurrency()}`, ''),
        seller: {
          '@type': getSellerEntity(listing),
          name: get(listing, 'contact.name')
        },
        url: getBoatUrl(listing)
      },
      weight: getWeightsMap(listing),
      itemCondition: getListingCondition(listing),
      productID: listing.id,
    });
  }
};

export const getListingCondition = (listing) => {
  switch (listing.condition) {
  case 'used':
    return 'UsedCondition';
  case 'new':
  default:
    return 'NewCondition';
  }
};

export const getWeightsMap = (listing) => {
  const weights = get(listing, 'specifications.weights');
  let weightList = [];
  if (has(weights, 'dry.lb')) {
    weightList.push({
      '@type': 'QuantitativeValue',
      unitText: 'lb',
      value: weights.dry.lb
    });
  }
  if (has(weights, 'dry.kg')) {
    weightList.push({
      '@type': 'QuantitativeValue',
      unitText: 'kg',
      value: weights.dry.kg
    });
  }
  return weightList;
};

export const getSellerEntity = (listing) => {
  return listing.isFSBO ? 'Person' : 'Organization';
};

export const getBreadCrumbSchema = (items) => {
  return ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement:
      items.map((element, index) => {
        return generateBreadCrumbSchema(index, element.link, element.title);
      })
  });
};

const generateBreadCrumbSchema = (index, link, title) => {
  return {
    '@type': 'ListItem',
    position: index,
    item: {
      '@id': link,
      name: title
    }
  };
};

export const getFaqPageSchema = (dynamicContent) => {
  const questionsAndAnswers = generateQuestionSchema(dynamicContent);
  return ({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questionsAndAnswers
  });
};

const generateQuestionSchema = (dynamicContent) => {
  const questionsAndAnswers = [];
  Object.keys(dynamicContent).forEach(key => {
    questionsAndAnswers.push({
      '@type': 'Question',
      name: dynamicContent[key].title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: dynamicContent[key].paragraphs.join(' ')
      }
    });
  });
  return questionsAndAnswers;
};
